import {StyleSheet, type CSSProperties} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {border, semanticColor} from "@khanacademy/wonder-blocks-tokens";

interface Props {
    cardWidth: number;
    cardHeight: number;
    bottomOffset: number;
    rightOffset: number;
    // Defaults to empty {}
    animationStyle?: CSSProperties;
    // Defaults to 0
    delay?: number;
}

const BlankCard: React.FC<Props> = (props) => {
    const {delay = 0, animationStyle = {}} = props;
    const delayClass: CSSProperties = {
        animationDelay: `${delay}s`,
        transitionDelay: `${delay}s`,
    };
    return (
        <View
            style={[
                styles.card,
                animationStyle,
                delayClass,
                {
                    width: props.cardWidth,
                    height: props.cardHeight,
                    bottom: props.bottomOffset,
                    right: props.rightOffset,
                },
            ]}
        />
    );
};

const styles = StyleSheet.create({
    card: {
        position: "absolute",
        display: "block",
        overflow: "hidden",
        borderStyle: "solid",
        borderWidth: border.width.thin,
        borderColor: semanticColor.border.primary,
        borderRadius: border.radius.radius_040,
        backgroundColor: semanticColor.surface.primary,
    },
});

export default BlankCard;
